import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IRoomDocument {
  data: {
    attributes: Record<string, unknown>;
    relationships?: object;
  };
}

function writableAttributes(room: ModelRegistry['room']): string[] {
  const attributes = ['beds', 'is_private'];

  return room.isNew ? ['room_type', ...attributes] : attributes;
}

export default class RoomSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const json = super.serialize(snapshot, options) as IRoomDocument;
    const room = snapshot.record as ModelRegistry['room'];

    json.data.attributes = pick(json.data.attributes, writableAttributes(room));

    if (!room.isNew) {
      delete json.data.relationships;
    }

    return json;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    room: RoomSerializer;
  }
}
